<div class="d-flex flex-column dl-application">
    <app-header></app-header>
    <main class="d-flex flex-row flex-grow-1">
        <app-navigation></app-navigation>
        <div class="d-flex flex-column flex-grow-1">
            <div class="d-flex flex-row align-items-center dl-cookie-header" *ngIf="!cookieBannerClosed">
                <div class="dl-cookie-header-text">
                    We use cookies to customize content for your viewing and for analytics.
                    If you continue to browse this website, we will assume that you are happy to receive all our
                    cookies.
                </div>
                <div class="d-flex dl-cookie-header-close align-items-center ml-auto">
                    <mat-icon aria-hidden="false" aria-label="close" class="dl-cookie-header-close-icon icon-light"
                        (click)="closeCookieBanner()">close</mat-icon>
                </div>
            </div>
            <div class="d-flex flex-row align-items-center dl-app-state-header"
                *ngIf="!!appState && !appState.initialized">
                <div class="dl-app-state-header-text">
                    {{appState.info}}
                </div>
            </div>
            <div class="flex-grow-1 dl-content">
                <router-outlet *ngIf="!isIframe"></router-outlet>
            </div>
        </div>
    </main>
</div>